import React, { useState } from "react";
import "./addSubCategory.css";

// components imports
import Loader from "../../../../../Components/CircularLoader/CircularLoader";
// apis imports
import { addSubCategory } from "../../../../../services/warehouse.services";
// library imports
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import { showSnackBar } from "../../../../../store/common/snackBarSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const AddSubCategory = ({ open, setOpen, setCategories }) => {
  const { t } = useTranslation(["inventory", "common"]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
  });
  const dispatch = useDispatch();

  const handelChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (formData.name === "") {
      dispatch(showSnackBar({
        text: t("categories.pleaseEnterSubcategoryName"),
        severity: "error",
      }))
      setLoading(false);
      return;
    }

    const response = await addSubCategory({
      ...formData,
      category_id: open.id,
    });
    // console.log("response", response.data.result);
    if (response.error) {
      dispatch(showSnackBar({
        text: t("common:messages.somethingWentWrong"),
        severity: "error",
      }))
      setLoading(false);
    } else {
      dispatch(showSnackBar({
        text: t("categories.subcategoryAddedSuccessfully"),
        severity: "success",
      }))
      setCategories((prevCategories) => {
        return {
          ...prevCategories,
          data: prevCategories?.data?.map((category) => {
            if (category.id === open.id) {
              return {
                ...category,
                subcategory: [response.data.result, ...category?.subcategory],
              };
            }
            return category;
          }),
        };
      });
      setLoading(false);
      setOpen(false);
      setFormData({ name: "" });
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen()}
        aria-labelledby="add-subcategory-modal-title"
        aria-describedby="add-subcategory-modal-description"
      >
        <div className="categoryPop__add_new_category_modal">
          <div className="categoryPop__add_new_category_modal_wrap">
            <div className="categoryPop__add_new_currency">
              <div className="categoryPop__add_new_category_header">
                <h3 className="categoryPop__add_new_category_title">
                  {t("categories.addSubcategory")}
                </h3>
              </div>
              <div className="categoryPop__add_new_category_body">
                <FormControl variant="outlined">
                  <InputLabel htmlFor="addSubcategoryName" size="small">
                    {t("categories.subcategoryName")}
                  </InputLabel>
                  <OutlinedInput
                    id="addSubcategoryName"
                    name="name"
                    value={formData.name}
                    size="small"
                    onChange={(e) => handelChange(e)}
                    label={t("categories.subcategoryName")}
                  />
                </FormControl>
                <div className="category__add_subcategory_modalfooter">
                  <div
                    className="category__add_subcategory_modalreset"
                    onClick={() => setOpen(false)}
                  >
                    {t("common:actions.cancel")}
                  </div>
                  <div
                    className="category__add_subcategory_modalsubmit"
                    onClick={handleSubmit}
                  >
                    {loading ? <Loader /> : t("common:actions.save")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddSubCategory;
